import https from 'https';
import { unsafeCoerce } from 'fp-ts/lib/function';
import { PreloadJob } from '../UnicronApp/preloader/PreloadJob';
import { makePreloadSlot } from '../UnicronApp/preloader/PreloadSlot';
import {
  SearchPromotionItem,
  SearchPromotionResponse,
} from '../common/components/SearchHeader/Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { env } from '../common/util/env';

export const preloadPromotedSpecialties = async (job: PreloadJob): Promise<void> => {
  const { server, services } = job;
  const { cache, logger, network } = services;

  if (!server || !network) return;

  // Override HTTPS agent when we want to ignore self-signed certificates in development.
  const fetchInitAgent =
    env.HTTPS_REJECT_UNAUTHORIZED === '0'
      ? {
          agent: new https.Agent({
            rejectUnauthorized: false,
          }),
        }
      : {};

  return await logger.profile('Preloading promoted specialties', async () => {
    try {
      const result = await network.fetch(
        `${env.MEGATRON_PROTOCOL}://${env.MEGATRON_CLUSTER_DOMAIN}/api/4/search/promoted`,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Type definition for fetch does not have agent property. May only work when node-fetch is being used.
        fetchInitAgent,
      );

      const json: unknown = await result.json();
      const response = unsafeCoerce<unknown, SearchPromotionResponse>(json);

      const cached = cache.get(PromotedSpecialtiesSlot) ?? [];

      if (response && response.data) {
        cache.set(PromotedSpecialtiesSlot, [...cached, ...response.data]);
      } else {
        cache.set(PromotedSpecialtiesSlot, [...cached]);
      }
    } catch (error: unknown) {
      logger.error('Failed while preloading promoted specialties', { error });
    }
  });
};

export const PromotedSpecialtiesSlot = makePreloadSlot(
  'PROMOTED_SPECIALTIES_CACHE',
  (): SearchPromotionItem[] => [],
);
